import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const MissingBinsCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Missing bins",
    cell: (row) => {
      return row.hasMissingBins ? "true" : "false";
    },
  };
